import { render } from "./BaseUserDataForm.vue?vue&type=template&id=4fb59f3e&scoped=true"
import script from "./BaseUserDataForm.vue?vue&type=script&lang=js"
export * from "./BaseUserDataForm.vue?vue&type=script&lang=js"

import "./BaseUserDataForm.vue?vue&type=style&index=0&id=4fb59f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb59f3e"]])

export default __exports__